export default __webpack_public_path__ + "static/media/Page_10.38f7951f.png";